import { Extensions } from "src/app/shared/types/enums/extensions.enums";
import { CircuitColorStyleScheme } from "src/app/shared/types/interfaces/config.interfaces";
import { JurisdictionKey } from "src/app/shared/types/enums/map.enums";
import { ICustomViewInitialState } from "../types/interfaces/custom-view.interface";
import { mapView } from "./mapview.config";
import { InitialLayerControlAssets } from "./layer-visibility.config";

export const systemPresetViewConfig: ICustomViewInitialState = {
  customViewName: "iGrid Visualization System Preset",
  is_default: false,
  assetLayers: InitialLayerControlAssets,
  basemapName: "Dark",
  colorScheme: CircuitColorStyleScheme.DEFAULT_CONDUCTOR_VIEW,
  jurisdictions: [JurisdictionKey.ALL],
  extensionLayer: Extensions.None,
  viewStateCenter: mapView.viewState.center,
  viewStateZoom: mapView.viewState.zoom,
};
